import { useClient } from '../supabase/client'

import { useQuery } from '@tanstack/vue-query'

type Props = {
   enabled?: boolean
   id?: string
   ids?: string[]
   impersonating?: boolean
}

export const useOrganization = (props: MaybeRef<Props>) => {
   const client = useClient()

   const query = useQuery({
      enabled: computed(() => toValue(props).enabled),
      queryKey: ['organization', props],
      queryFn: async () => {
         const query = client
            .schema('dashboard')
            .from('organization')
            .select(
               `
               *,
               organizationpoints!organization_id(*),
               user_organization!organization_id(*)
            `
            )
            .order('translated_name', { ascending: true })
            .throwOnError()

         if (toValue(props).ids) {
            query.in('id', toValue(props).ids || [])
         }

         if (toValue(props).id) {
            query.eq('id', toValue(props).id || '')
         }

         if (toValue(props).impersonating) {
            query.eq('type', 'OT_GENERIC')
         }

         return (await query).data
      },
   })

   onServerPrefetch(async () => {
      if (toValue(props).enabled !== false) {
         await query.suspense()
      }
   })

   return query
}
